import React from 'react';
import {convertSecondToTime} from 'lib/utils';

interface ITimeProps {
  playingTime: number;
  totalDuration: number;
}

/**
 * 컨트롤 바 > 영상 시간 컴포넌트
 */
const Time = ({playingTime, totalDuration}: ITimeProps) => {
  const convertPlayingTime = convertSecondToTime(playingTime);
  const totalTimeDuration = convertSecondToTime(totalDuration);

  return (
    <div className='time_display' style={{display: 'block'}}>
      <span className='time-current'>{convertPlayingTime}</span>/
      <span className='time-duration'>{totalTimeDuration}</span>
    </div>
  );
};

export default Time;
